export default __webpack_public_path__ + "Smiley.84792936.svg";